import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, messageErreur } from "@/lib/api";
import { ChoixListe } from "@/pages/parametres/ChoixListe";
import { TestWhatsApp } from "./TestWhatsApp";

const NIVEAUX = [{ code: "propose", label: "Propose, j'approuve" }, { code: "auto", label: "Exécute seule" }];

export default function ReglagesIA() {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/ia/reglages").then((x) => setR(x.data)); }, []);
  const maj = async (corps) => {
    try { const { data } = await api.put("/ia/reglages", corps); setR(data); toast.success("Réglage enregistré."); }
    catch (e) { toast.error(messageErreur(e)); }
  };
  if (!r) return null;
  const modeles = Object.entries(r.modeles_disponibles).map(([code, label]) => ({ code, label }));
  return (
    <div className="space-y-4" data-testid="ai-settings">
      <h2 className="text-base md:text-lg font-bold">IA</h2>
      <div className="at-card p-5 space-y-1 text-sm">
        <p className="font-bold">Règles de l'IA</p>
        <p>Pas de clone vocal : les messages aux clients sont uniquement écrits (SMS, WhatsApp, e-mail).</p>
        <p>Aucun appel téléphonique de l'IA vers les particuliers.</p>
        <p className="at-muted">Mode simulation jusqu'au lot 7 : phrases types, coût fictif, rien n'est débité.</p>
      </div>
      <section className="at-card p-5 space-y-3" data-testid="ai-autonomy">
        <p className="font-bold">Autonomie, action par action</p>
        {Object.entries(r.outils).map(([code, label]) => (
          <div key={code} className="space-y-1.5">
            <p className="text-sm font-semibold">{label}</p>
            <ChoixListe valeur={r.autonomie[code]} onChange={(v) => maj({ autonomie: { [code]: v } })} options={NIVEAUX} testId={`ai-autonomy-${code}`} />
          </div>
        ))}
      </section>
      <section className="at-card p-5 space-y-3" data-testid="ai-models">
        <p className="font-bold">Modèle par fonction</p>
        {Object.entries(r.fonctions).map(([code, label]) => (
          <div key={code} className="space-y-1.5">
            <p className="text-sm font-semibold">{label}</p>
            <ChoixListe valeur={r.modeles[code]} onChange={(v) => maj({ modeles: { [code]: v } })} options={modeles} testId={`ai-model-${code}`} />
          </div>
        ))}
      </section>
      <TestWhatsApp />
    </div>
  );
}
